import Layout from '@/layout'

const asyncReagentManagementRoutes =
{
  path: '/stock/reagentManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '试剂管理',
  funcPerms: 'stock:reagent',
  alwaysShow: true,
  meta: {
    title: '试剂管理',
    icon: 'reagent',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'reagent/inventoryQuery',
      component: () => import('@/views/oa/reagentManagement/inventoryQuery/index'),
      funcPerms: 'stock:reagent:stock:query',
      name: 'reagentInventoryQuery',
      meta: {
        title: '库存查询',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: 'reagent/purchasePlan',
    //   component: () => import('@/views/oa/reagentManagement/purchasePlan/index'),
    //   funcPerms: 'oa:reagent:purchasePlan',
    //   name: 'reagentPurchasePlan',
    //   meta: {
    //     title: '试剂采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchasePlan/view',
    //   component: () => import('@/views/oa/reagentManagement/purchasePlan/view'),
    //   funcPerms: 'oa:reagent:purchasePlan:view',
    //   name: 'reagentPurchasePlanView',
    //   hidden: true,
    //   meta: {
    //     title: '查看试剂采购计划',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchasePlan/viewSummary',
    //   component: () => import('@/views/oa/reagentManagement/purchasePlan/viewSummary'),
    //   funcPerms: 'oa:reagent:purchasePlan:viewSummary',
    //   name: 'reagentPurchaseviewSummary',
    //   hidden: true,
    //   meta: {
    //     title: '查看汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchasePlan/detail',
    //   component: () => import('@/views/oa/reagentManagement/purchasePlan/detail'),
    //   funcPerms: 'oa:reagent:purchasePlan:detail',
    //   name: 'reagentPurchasePlanDetail',
    //   hidden: true,
    //   meta: {
    //     title: '查看明细',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchasePlan/submitReview',
    //   component: () => import('@/views/oa/reagentManagement/purchasePlan/submitReview'),
    //   funcPerms: 'oa:reagent:purchasePlan:submitReview',
    //   name: 'reagentPurchasePlan-submitReview',
    //   hidden: true,
    //   meta: {
    //     title: '提交审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchase',
    //   component: () => import('@/views/oa/reagentManagement/purchase/index'),
    //   funcPerms: 'oa:reagent:purchaseApply',
    //   name: 'reagentPurchase',
    //   meta: {
    //     title: '试剂采购',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchase/add',
    //   component: () => import('@/views/oa/reagentManagement/purchase/add'),
    //   funcPerms: 'oa:reagent:purchaseApply:add',
    //   name: 'ReagentPurchaseApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'reagent/purchase/edit',
    //   component: () => import('@/views/oa/reagentManagement/purchase/add'),
    //   funcPerms: 'oa:reagent:purchaseApply:edit',
    //   name: 'ReagentPurchaseApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'reagent/purchase/view',
    //   component: () => import('@/views/oa/reagentManagement/purchase/view'),
    //   funcPerms: 'oa:reagent:purchaseApply:view',
    //   name: 'reagentPurchaseApplication-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看采购申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: false
    //   }
    // },
    // {
    //   path: 'reagent/purchaseReview',
    //   component: () => import('@/views/oa/reagentManagement/purchaseReview/index'),
    //   funcPerms: 'oa:reagent:purchaseReview',
    //   name: 'reagentPurchaseReview',
    //   meta: {
    //     title: '试剂采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: 'reagent/purchaseReview/view',
    //   component: () => import('@/views/oa/reagentManagement/purchaseReview/view'),
    //   funcPerms: 'oa:reagent:purchaseReview:view',
    //   name: 'reagentPurchaseReview-view',
    //   hidden: true,
    //   meta: {
    //     title: '查看试剂采购审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentApplication',
    //   component: () => import('@/views/oa/reagentManagement/reagentApplication/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentApplication',
    //   meta: {
    //     title: '试剂申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentApplicationAdd',
    //   component: () => import('@/views/oa/reagentManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentApplicationAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增试剂申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentApplicationEdit',
    //   component: () => import('@/views/oa/reagentManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentApplicationEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑试剂申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentApplicationView',
    //   component: () => import('@/views/oa/reagentManagement/reagentApplication/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentApplicationView',
    //   hidden: true,
    //   meta: {
    //     title: '查看试剂申请',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/warehouserVerify',
    //   component: () => import('@/views/oa/reagentManagement/warehouserVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'warehouserVerify',
    //   meta: {
    //     title: '库管审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/warehouserVerify/view',
    //   component: () => import('@/views/oa/reagentManagement/warehouserVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'warehouserVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '库管审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/depttHeaderVerify',
    //   component: () => import('@/views/oa/reagentManagement/depttHeaderVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'depttHeaderVerify',
    //   meta: {
    //     title: '科主任审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/depttHeaderVerify/view',
    //   component: () => import('@/views/oa/reagentManagement/depttHeaderVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'depttHeaderVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/depttHeaderSummary',
    //   component: () => import('@/views/oa/reagentManagement/depttHeaderSummary/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'depttHeaderSummary',
    //   meta: {
    //     title: '科主任汇总',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/depttHeaderSummary/view',
    //   component: () => import('@/views/oa/reagentManagement/depttHeaderSummary/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'depttHeaderSummaryView',
    //   hidden: true,
    //   meta: {
    //     title: '科主任汇总详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/financeVerify',
    //   component: () => import('@/views/oa/reagentManagement/financeVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'financeVerify',
    //   meta: {
    //     title: '财务审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/financeVerify/view',
    //   component: () => import('@/views/oa/reagentManagement/financeVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'financeVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '财务审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/affairsDeptVerify',
    //   component: () => import('@/views/oa/reagentManagement/affairsDeptVerify/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'affairsDeptVerify',
    //   meta: {
    //     title: '总务科审核',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/affairsDeptVerify/view',
    //   component: () => import('@/views/oa/reagentManagement/affairsDeptVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'affairsDeptVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '总务科审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentStorage',
    //   component: () => import('@/views/oa/reagentManagement/reagentStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentStorage',
    //   meta: {
    //     title: '试剂入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentStorage/add',
    //   component: () => import('@/views/oa/reagentManagement/reagentStorage/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentStorageAdd',
    //   hidden: true,
    //   meta: {
    //     title: '入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentOutbound',
    //   component: () => import('@/views/oa/reagentManagement/reagentOutbound/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentOutbound',
    //   meta: {
    //     title: '试剂出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentOutbound/out',
    //   component: () => import('@/views/oa/reagentManagement/reagentOutbound/out'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentOutboundOut',
    //   hidden: true,
    //   meta: {
    //     title: '出库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/reagentOutbound/view',
    //   component: () => import('@/views/oa/reagentManagement/reagentOutbound/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'reagentOutboundView',
    //   hidden: true,
    //   meta: {
    //     title: '出库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/deptManagerStorage',
    //   component: () => import('@/views/oa/reagentManagement/deptManagerStorage/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'deptManagerStorage',
    //   meta: {
    //     title: '科室库管入库',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/deptManagerStorage/view',
    //   component: () => import('@/views/oa/reagentManagement/deptManagerStorage/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'deptManagerStorageView',
    //   hidden: true,
    //   meta: {
    //     title: '科室库管入库详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'reagent/inventoryDetails',
      component: () => import('@/views/oa/reagentManagement/inventoryDetails/index'),
      funcPerms: 'stock:reagent:stockin:detail',
      name: 'reagent/inventoryDetails',
      meta: {
        title: '入库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'reagent/OutboundDetail',
      component: () => import('@/views/oa/reagentManagement/OutboundDetail/index'),
      funcPerms: 'stock:reagent:stockout:detail',
      name: 'reagent/OutboundDetail',
      meta: {
        title: '出库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'reagent/deptUseApply',
      component: () => import('@/views/oa/reagentManagement/deptUseApply/index'),
      funcPerms: 'stock:reagent:useApply',
      name: 'reagent/deptUseApply',
      meta: {
        title: '使用申领',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'reagent/deptUseApply/query',
      component: () => import('@/views/oa/reagentManagement/deptUseApply/query'),
      funcPerms: 'stock:reagent:useApply:query',
      name: 'reagent/deptUseApplyQuery',
      hidden: true,
      meta: {
        title: '查询库存',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/deptUseApply/edit',
    //   component: () => import('@/views/oa/reagentManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'deptUseApplyEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑申领',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/deptUseApply/view',
    //   component: () => import('@/views/oa/reagentManagement/deptUseApply/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'deptUseApplyView',
    //   hidden: true,
    //   meta: {
    //     title: '申领详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'reagent/deptUseApplyVerify',
      component: () => import('@/views/oa/reagentManagement/deptUseApplyVerify/index'),
      funcPerms: 'stock:reagent:applyAudit',
      name: 'reagent/deptUseApplyVerify',
      meta: {
        title: '申领审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/deptUseApplyVerify/view',
    //   component: () => import('@/views/oa/reagentManagement/deptUseApplyVerify/view'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'deptUseApplyVerifyView',
    //   hidden: true,
    //   meta: {
    //     title: '使用申领审核详情',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'reagent/inventoryImport',
      component: () => import('@/views/oa/reagentManagement/inventoryImport/index'),
      funcPerms: 'stock:reagent:stockImport',
      name: 'reagent/inventoryImport',
      meta: {
        title: '库存导入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
    // {
    //   path: '/storagePlace',
    //   component: () => import('@/views/oa/reagentManagement/storagePlace/index'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'storagePlace',
    //   meta: {
    //     title: '存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/storagePlace/add',
    //   component: () => import('@/views/oa/reagentManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'storagePlaceAdd',
    //   hidden: true,
    //   meta: {
    //     title: '新增存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    // {
    //   path: '/storagePlace/edit',
    //   component: () => import('@/views/oa/reagentManagement/storagePlace/add'),
    //   funcPerms: 'oa:hr:manager',
    //   name: 'storagePlaceEdit',
    //   hidden: true,
    //   meta: {
    //     title: '编辑存放地点',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // }
  ]
}

export default asyncReagentManagementRoutes
